import Button, { DEFAULT, PRIMARY, TRANSPARENT } from '@/common/components/Button/Button';
import ButtonContainer from '@/common/components/ButtonContainer/ButtonContainer';
import Modal, { CENTER } from '@/common/components/Modal/Modal';
import { AccessInheritanceContent } from '@/drive/components/AccessInheritanceConfirmation/AccessInheritanceConfirmation.constants';
import { AccessInheritanceDecision } from '@/drive/types/AccessInheritanceDecision';

import styles from './AccessInheritanceConfirmation.module.css';

export interface AccessInheritanceConfirmationProps {
  content: AccessInheritanceContent;
  isShowed: boolean;
  onSelect: (decision: AccessInheritanceDecision) => void;
  onClose: () => void;
}

function AccessInheritanceConfirmation(props: AccessInheritanceConfirmationProps) {
  const { content, isShowed, onSelect, onClose } = props;

  return (
    <Modal
      isShowed={isShowed}
      onClose={onClose}
      title={content.title}
      position={CENTER}
      isCloseHidden
      contentClassName={styles.modal}
      headerClassName={styles.header}
      footerClassName={styles.footer}
      renderModalFooter={() => (
        <ButtonContainer className={styles.footerButtons}>
          <Button
            color={TRANSPARENT}
            className={styles.cancelButton}
            aria-label="Cancel access change"
            onClick={() => onSelect(AccessInheritanceDecision.Cancel)}
          >
            {content.cancelLabel}
          </Button>

          <ButtonContainer>
            {content.keepLabel && (
              <Button
                color={DEFAULT}
                aria-label="Leave access unchanged"
                onClick={() => onSelect(AccessInheritanceDecision.LeaveUnchanged)}
              >
                {content.keepLabel}
              </Button>
            )}

            <Button color={PRIMARY} aria-label="Confirm access change" onClick={() => onSelect(content.okDecision)}>
              {content.okLabel}
            </Button>
          </ButtonContainer>
        </ButtonContainer>
      )}
    >
      <div className={styles.content}>
        {content.paragraphs.map((paragraph) => (
          <p key={paragraph} className={styles.paragraph}>
            {paragraph}
          </p>
        ))}
      </div>
    </Modal>
  );
}

export default AccessInheritanceConfirmation;
